import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { css } from "styled-components";

searchInputStyles!.input!.cssOverrides!.formInputWrapper = css`
    padding-right: 30px;
`;
